export const settingConstants = {
	Setting_Get_Request : "SETTING_GET_ALL_STARTED",
	Setting_Get_Success : "SETTING_GET_ALL_COMPLETED",
	Setting_Get_Failure: "SETTING_GET_ALL_FAILED",

	SettingContentUpdateRequest: "SETTING_CONTENT_UPDATE_STARTED",
	SettingContentUpdateSuccess: "SETTING_CONTENT_UPDATE_COMPLETED",
	SettingContentUpdateFailure: "SETTING_CONTENT_UPDATE_FAILED",

	GetSettingContentRequest: "GET_SETTING_CONTENT_STARTED",
	GetSettingContentSuccess: "GET_SETTING_CONTENT_COMPLETED",
	GetSettingContentFailure: "GET_SETTING_CONTENT_FAILED",

	SettingStatusUpdateRequest: "SETTING_STATUS_UPDATE_STARTED",
	SettingStatusUpdateSuccess: "SETTING_STATUS_UPDATE_COMPLETED",
	SettingStatusUpdateFailure: "SETTING_STATUS_UPDATE_FAILED",
}